// extracted by mini-css-extract-plugin
export default {"mesh":"Mesh--mesh--+W+zN","mesh__canvas":"Mesh--mesh__canvas--elsVi","meshIsInverted":"Mesh--meshIsInverted--Dtpwt","meshIsIpad":"Mesh--meshIsIpad--v9o31"};